import { FaChevronLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const BackButton = () => {
    const navigate = useNavigate();
    return (
        <button
            onClick={() => navigate(-1)}
            className="text-gray-500 cursor-pointer hover:text-gray-600"
        >
            <FaChevronLeft className="mr-2" size={20}/>
        </button>
    )
};

export default BackButton;